import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          Shawn Temple, master developer of Miller’s Landing, Managing Director of P3 Advisors, and
          a resident of Castle Rock, points out another important component of a SmartTown.
          “Miller’s Landing will be the connection to bring smart solutions to Castle Rock
          government and citizens,” Temple says. “It is very exciting and challenging to deliver
          such a pioneering development.”
        </p>
      </section>
    </>
  );
}

export default Chapter3;
